export const formatNumber = (n) => {
  if (n >= 1000000000) {
    return Math.floor(n / 1000000000) + ' MM';
  } else if (n >= 1000000) {
    return Math.floor(n / 1000000) + 'M';
  } else if (n >= 1000) {
    return Math.floor(n / 1000) + 'k';
  }else {
    return n.toString();
  }
};

function addThousandsSeparator(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export const formatMount = (number, currency) => {
  // Redondear el número a 2 decimales de manera consistente
  const roundedNumber = Math.round(number * 100) / 100;
  
  if(currency?.toLowerCase() === 'ars'){
    return roundedNumber.toLocaleString('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  } else {
    return roundedNumber.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
};